/** O que não coube nos cinco destinos do polegar (DESIGN.md § 2.2).
 *
 * Existe para que a navegação inferior possa ter cinco alvos **sem esconder
 * nada**: Indicadores, Pessoas, Etiquetas, WhatsApp e Auditoria continuam a um
 * toque, e a conta e a saída deixam de depender de uma barra que, no celular,
 * quebrava em três linhas.
 *
 * A lista chega pronta de quem sabe o que a pessoa pode ver — os portões de
 * permissão vivem no `App`, junto dos da barra superior, para as duas
 * navegações nunca discordarem sobre o que existe.
 */

import { Botao } from "./Botao";

export interface ItemDoMenu {
  rotulo: string;
  /** Uma linha dizendo o que se faz ali. No desktop o nome basta, porque a
   * barra é varrida de relance; numa lista vertical, cada linha é lida. */
  descricao: string;
  aoAcionar: () => void;
}

export function MaisDoCelular({
  itens,
  aoVoltar,
}: {
  itens: readonly ItemDoMenu[];
  aoVoltar: () => void;
}) {
  return (
    <section
      aria-label="Mais"
      className="mx-auto flex w-full max-w-[900px] flex-col gap-6 px-6 py-8"
    >
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div className="flex flex-col gap-1">
          <p className="font-texto text-micro uppercase tracking-wide text-texto-suave">
            Sua organização
          </p>
          <h2 className="font-display text-display-md tracking-tight text-texto">Mais</h2>
        </div>
        <Botao variante="fantasma" onClick={aoVoltar}>
          Voltar ao funil
        </Botao>
      </header>

      <ul className="flex flex-col divide-y divide-borda rounded-lg border border-borda bg-superficie">
        {itens.map((item) => (
          <li key={item.rotulo}>
            <button
              type="button"
              onClick={item.aoAcionar}
              className="flex w-full flex-col gap-0.5 px-4 py-3 text-left hover:bg-canvas focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-acao-viva"
            >
              <span className="font-texto text-body text-texto">{item.rotulo}</span>
              <span className="font-texto text-caption text-texto-suave">{item.descricao}</span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
